import React from 'react';

interface CallingCardProps {
  callingId: string;
  icon: string;
  name: string;
  epithet: string;
  accent: string;
  selected: boolean;
  onSelect: () => void;
}

export const CallingCard: React.FC<CallingCardProps> = ({
  callingId,
  icon,
  name,
  epithet,
  accent,
  selected,
  onSelect,
}) => (
  <button
    type="button"
    className={`cc-calling-card ${selected ? 'selected' : ''}`}
    onClick={onSelect}
    aria-pressed={selected}
    aria-label={`${name}, ${epithet}`}
    data-calling-id={callingId}
    style={{ '--cc-calling-accent': accent } as React.CSSProperties}
  >
    <span className="cc-calling-icon" aria-hidden="true">{icon}</span>
    <span className="cc-calling-name">{name}</span>
  </button>
);
